import axios from "axios";
import { PUBLIC_ROUTES } from "utils/constants";
import { clearLocalStorage } from "utils/auth";
const API_URL = process.env.REACT_APP_TENANT_API_URL;

//  GET API
export async function callTenantGetApi({ url, body, headers }) {
  try {
    const authHeader = localStorage.getItem("authorization")
      ? { authorization: localStorage.getItem("authorization") }
      : {};

    const result = await axios({
      url: API_URL + url,
      method: "GET",
      headers: {Bearer: "Bearer " + localStorage.getItem("authorization"), ...headers },
      data: body,
      timeout: 120000,
    });
    return result;
  } catch (error) {
    if (error?.response?.status === 401 && !PUBLIC_ROUTES.includes(window.location.pathname)) {
      clearLocalStorage();
      window.location.href = "/login";
    }
    // throw error;
    if (error && error.response) {
      return error.response;
    }
  }
}

//  POST API
export async function callTenantPostApi({ url, body, headers }) {
  console.log("API_URL", API_URL);
  try {
    const authHeader = localStorage.getItem("authorization")
      ? { authorization: localStorage.getItem("authorization") }
      : {};

    const result = await axios({
      url: API_URL + url,
      method: "POST",
      headers: { ...authHeader, ...headers },
      data: body,
      timeout: 120000,
    });
    return result;
  } catch (error) {
    if (error?.response?.status === 401 && !PUBLIC_ROUTES.includes(window.location.pathname)) {
      clearLocalStorage();
      window.location.href = "/login";
    }
    // throw error;
    if (error && error.response) {
      return error.response;
    }
  }
}

// PUT API
export async function callTenantPutApi({ url, body, headers }) {
  try {
    const authHeader = localStorage.getItem("authorization")
      ? { authorization: localStorage.getItem("authorization") }
      : {};

    const result = await axios({
      url: API_URL + url,
      method: "PUT",
      headers: { ...authHeader, ...headers },
      data: body,
      timeout: 120000,
    });
    return result;
  } catch (error) {
    if (error?.response?.status === 401 && !PUBLIC_ROUTES.includes(window.location.pathname)) {
      clearLocalStorage();
      window.location.href = "/login";
    }
    // throw error;
    if (error && error.response) {
      return error.response;
    }
  }
}

// DELETE API
export async function callTenantDeleteApi({ url, body, headers }) {
  try {
    const authHeader = localStorage.getItem("authorization")
      ? { authorization: localStorage.getItem("authorization") }
      : {};

    const result = await axios({
      url: API_URL + url,
      method: "DELETE",
      headers: { ...authHeader, ...headers },
      data: body,
      timeout: 120000,
    });
    return result;
  } catch (error) {
    if (error?.response?.status === 401 && !PUBLIC_ROUTES.includes(window.location.pathname)) {
      clearLocalStorage();
      window.location.href = "/login";
    }
    // throw error;
    if (error && error.response) {
      return error.response;
    }
  }
}
